import { api } from '@/api'

export type DeviceUploadedDocument = {
  id: number
  name: string
  url: string
}

export type PendingUploadedDocument = {
  id: string
  name: string
}

export type UploadFeaturesDocListItem = DeviceUploadedDocument | PendingUploadedDocument

export type AddDeviceDocumentsResponse = {
  success: boolean
  documents?: string[]
}

export type DeleteDeviceDocumentsResponse = {
  success: boolean
  documents?: DeviceUploadedDocument[]
}

const uploadDocService = api.injectEndpoints({
  endpoints: (build) => ({
    uploadFeaturesDocs: build.mutation<AddDeviceDocumentsResponse, FormData>({
      query: (body) => ({
        url: '/devices/addDeviceDocuments',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Properties'],
    }),
    deleteFeaturesDoc: build.mutation<
      DeleteDeviceDocumentsResponse,
      { deviceId: number; id: number | string }
    >({
      query: (body) => ({
        url: '/devices/deleteDeviceDocument',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Properties'],
    }),
  }),
})

export const { useUploadFeaturesDocsMutation, useDeleteFeaturesDocMutation } =
  uploadDocService
